<template>
  <div>
    <flowy-drag-handle>
      <b-card
        class="border border-ligth bg-white grab mb-0 item-box hider shadow"
        :class="{ 'bg-gray': node.type == 'Department' || node.type == 'Process', 'border-gray': node.type == 'Department' || node.type == 'Process' }"
      >
        <div class="row items-center no-wrap">
          <div class="col">
            <h6>
              <i v-if="node.icon" :class="node.icon" class="align-middle font-size-16"></i>
              {{ title }}
            </h6>
          </div>
        </div>

        <div v-html="description" />

        <div class="text-right">
          <!-- Organizasyon şeması: alt kutu buradan eklenir (birim şemasında alt birim, süreç şemasında yeni süreç) -->
          <i v-if="node.addChild !== false" class="bx bx-plus text-success hand hidden mr-3" v-b-tooltip.hover :title="addChildTitle" @click="addChild()"></i>
          <i v-if="!node.root" class="bx bx-pencil text-primary hand hidden mr-3" v-b-tooltip.hover :title="$t('common.edit')" @click="edit()"></i>
          <i
            v-if="!node.root && node.type == 'Department'"
            class="bx bx-search-alt-2 text-main hand hidden mr-3 font-size-16"
            v-b-tooltip.hover
            :title="$t('process.plural')"
            @click="expand()"
          ></i>
          <i v-if="!node.root" class="bx bx-trash-alt text-danger hand hidden" v-b-tooltip.hover :title="$t('common.delete')" @click="remove()"></i>
        </div>
      </b-card>
    </flowy-drag-handle>
  </div>
</template>

<script>
export default {
  props: ["remove", "node", "title", "description"],
  computed: {
    addChildTitle() {
      if (this.node.addChildLabel) return this.$t(this.node.addChildLabel);
      return this.node.root ? this.$t("department.add-root") : this.$t("department.add-child");
    },
  },
  methods: {
    addChild() {
      return this.$root.$emit("add-child", this.node);
    },
    edit() {
      return this.$root.$emit("edit", this.node);
    },
    expand() {
      return this.$root.$emit("expand", this.node);
    },
  },
};
</script>

<style scoped>
.item-box {
  width: 200px;
}
.item-box * {
  font-size: 11px;
}

.card-body {
  padding: 10px !important;
}

.border-ligth {
  border-color: rgb(214, 214, 214) !important;
}

.border-gray {
  border-color: rgb(157, 193, 235) !important;
}
.bg-gray {
  background-color: rgb(226, 236, 251) !important;
}
</style>
